import script from "./AssetAdminViewScans.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetAdminViewScans.vue?vue&type=script&setup=true&lang=js"

import "./AssetAdminViewScans.vue?vue&type=style&index=0&id=3d510eed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d510eed"]])

export default __exports__